import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA008_Request,
  IAPI_STA008_Response,
  IAPI_STA039_Request,
  IAPI_STA039_Response,
  IAPI_STA040_Request,
  IAPI_STA040_Response,
} from "../../../type/apiType";

// 退職者詳細情報更新API
// 仕様書_法人職員
const httpIAPI_STA008 = async (
  param: IAPI_STA008_Request
): Promise<IAPI_STA008_Response> => {
  let res = await http.post(ApiUrl.API_STA008, {
    ...param,
  });
  return res.data;
};

// 源泉徴収票参照API
const httpIAPI_STA039 = async (
  param: IAPI_STA039_Request
): Promise<IAPI_STA039_Response> => {
  let res = await http.post(ApiUrl.API_STA039, {
    ...param,
  });
  return res.data;
};

// 源泉徴収票更新API
const httpIAPI_STA040 = async (
  param: IAPI_STA040_Request
): Promise<IAPI_STA040_Response> => {
  let res = await http.post(ApiUrl.API_STA040, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_STA008, httpIAPI_STA039, httpIAPI_STA040 };
